"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var service_service_1 = require("src/app/Services/service.service");
var WickedApiClient_1 = require("./../../../../api/WickedApiClient");
var core_2 = require("@angular/core");
var environment_1 = require("src/environments/environment");
var MessageComponent = /** @class */ (function () {
    function MessageComponent(mainService, dialog) {
        this.mainService = mainService;
        this.dialog = dialog;
        this.images = [];
        this.messageNick = "";
    }
    MessageComponent.prototype.ngOnInit = function () {
        if (this.message.images.length > 0) {
            if (this.images[this.conversation.conversationId] == null) {
                this.images = [];
            }
            this.images = this.prepareImages(this.message);
        }
        this.swiperConfig = {
            navigationPlacement: 'inside',
            pagination: this.images.length > 1 ? true : false,
            paginationPlacement: 'outside',
            imgBackgroundSize: 'contain'
        };
        this.messageNick = this.resolveMessageSenderNick(this.conversation, this.message);
    };
    MessageComponent.prototype.formatDate = function (date) {
        return date.format("MM/DD/YYYY hh:mm A");
    };
    MessageComponent.prototype.getUser = function () {
        return {
            name: "lolek",
            picture: 'https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/gettyimages-1038241336a-1587582575.jpg?crop=1.00xw:0.669xh;0,0.0833xh&resize=640:*',
            status: 'online',
            color: "red"
        };
    };
    MessageComponent.prototype.resolveMessageSenderNick = function (conversation, message) {
        if (message.senderId == this.mainService.userService.getUserId()) {
            return "You";
        }
        else {
            if (conversation.senderId == message.senderId) {
                return conversation.senderNick;
            }
            else
                return conversation.receiverNick;
        }
    };
    MessageComponent.prototype.hasImages = function (conversationIndex, messageIndex) {
        return this.images != null && this.images.length > 0;
    };
    MessageComponent.prototype.prepareImages = function (message) {
        var images = message.images.map(function (img) {
            return environment_1.environment.apiBaseUrl + "/FileGet/" + img.fileName;
        });
        return images;
    };
    MessageComponent.prototype.openDialog = function (imageUrl) {
        var dialogRef = this.dialog.open(this.imageDialogRef, {
            width: '90%',
            data: imageUrl,
            backdropClass: "imageDialog__backdrop",
            panelClass: "imageDialog__panel"
        });
    };
    MessageComponent.prototype.imageClick = function (imageIndex) {
        this.openDialog(this.images[imageIndex]);
    };
    return MessageComponent;
}());
exports.MessageComponent = MessageComponent;
